import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { derived } from 'svelte/store';
import { Container } from '../services/container';
import { Logger } from '../services/logger';
import { AppState } from './stores';
dayjs.extend(utc);
export function getImageMultipleSizes(imagePath, format = 'png') {
    return `${process.env.BASE_URL}${imagePath}.${format}, ${process.env.BASE_URL}${imagePath}@2x.${format} 2x, ${process.env.BASE_URL}${imagePath}@3x.${format} 3x`;
}
export function isAndroid() {
    return navigator.userAgent.toLowerCase().indexOf('android') > -1;
}
export function isIOS() {
    return navigator.userAgent.match(/(iPod|iPhone|iPad)/);
}
export function isMobile() {
    let check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
            check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
export function isXiaomiDevice() {
    const userAgent = navigator.userAgent.toLowerCase();
    const knownModels = ['mi', 'redmi', 'xiaomi', 'miui'];
    return (knownModels.some(model => userAgent.includes(model)) ||
        window.miuiVersion);
}
export const toCamelCase = (str) => str.replace(/-(.)/g, (_, p) => p.toUpperCase());
export const cssTextToObj = (cssText) => {
    return cssText.split(';').reduce(function (ruleMap, ruleString) {
        const [key, value] = ruleString.split(':');
        ruleMap[key.trim()] = value.trim();
        return ruleMap;
    }, {});
};
export function removeTrailingZeros(moneyAmount) {
    return moneyAmount.replace(/[.,]00$/gi, '');
}
export const getHexToRgbColor = hex => hex
    .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => `#${r}${r}${g}${g}${b}${b}`)
    .substring(1)
    .match(/.{2}/g)
    .map(x => parseInt(x, 16));
export function findGetParameter(parameterName) {
    var result = null, tmp = [];
    location.search
        .substr(1)
        .split('&')
        .forEach(function (item) {
        tmp = item.split('=');
        if (tmp[0] === parameterName)
            result = decodeURIComponent(tmp[1]);
    });
    return result;
}
export function getParamsVisualTest() {
    return {
        enabled: !!findGetParameter('twism-visual-test') && !process.env.production,
        page: `/${findGetParameter('twism-page')}`,
        lang: findGetParameter('twism-lang'),
        color: findGetParameter('twism-color')
    };
}
export const getReferralProgramType = referralProgram => {
    const hasReferredDiscount = !!Number(referralProgram.referredDiscount);
    const hasReferringDiscount = !!Number(referralProgram.referringDiscount);
    if (hasReferredDiscount && hasReferringDiscount) {
        return 'both';
    }
    if (!hasReferredDiscount) {
        return 'only-referring';
    }
    return 'only-referred';
};
export function formatMoneyToParts(country, amount) {
    return new Intl.NumberFormat(country.lang, {
        style: 'currency',
        currency: country.currency
    }).formatToParts(Number(amount));
}
export function formatMoney(country, amount, withTrailingZeros) {
    let result = null;
    try {
        result = new Intl.NumberFormat(country.lang, {
            style: 'currency',
            currency: country.currency
        }).format(Number(amount));
    }
    catch (e) {
        result = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(Number(amount));
    }
    return withTrailingZeros ? result : removeTrailingZeros(result);
}
export const setWidgetConfiguration = (footerVisibility, popOverAutoHeight) => {
    AppState.update(state => (Object.assign(Object.assign({}, state), { website: Object.assign(Object.assign({}, state.website), { footerVisibility,
            popOverAutoHeight }) })));
};
export function getErrorMessage(e) {
    var _a, _b, _c, _d;
    const constraints = (_d = (_c = (_b = (_a = e.res) === null || _a === void 0 ? void 0 : _a.body) === null || _b === void 0 ? void 0 : _b.message) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.constraints;
    if (constraints) {
        const message = Object.values(constraints)[0];
        if (message) {
            return message;
        }
    }
    return e.message;
}
export function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}
export const onChangePageWeb = callback => {
    window.addEventListener('locationchange', callback);
    history.pushState = (f => function pushState() {
        var ret = f.apply(this, arguments);
        window.dispatchEvent(new Event('locationchange'));
        return ret;
    })(history.pushState);
    window.addEventListener('popstate', () => {
        window.dispatchEvent(new Event('locationchange'));
    });
};
export const maskEmail = (email, isHtml) => {
    const [mail, provider] = email.split('@');
    const asterisks = `${isHtml ? '<sub>' : ''}*****${isHtml ? '</sub>' : ''}`;
    const maskedEmail = `${mail.slice(0, 3)}${asterisks}${mail[mail.length - 1]}@${provider}`;
    return maskedEmail;
};
export const maskPhone = (phone, isHtml) => {
    if (phone === null || phone === void 0 ? void 0 : phone.length) {
        const asterisks = `${isHtml ? '<sub>' : ''}*****${isHtml ? '</sub>' : ''}`;
        return `${phone[0]}${phone[1]}${asterisks}${phone.slice(phone.length - 4)}`;
    }
};
export const pluralize = (noun, count, suffix = 's') => `${noun}${Number(count) !== 1 ? suffix : ''}`;
export const pluralizeI18n = (text, count) => `${text}.${Number(count) !== 1 ? 'plural' : 'singular'}`;
export function isSafariBrowser() {
    const userAgent = window.navigator.userAgent;
    const vendor = window.navigator.vendor;
    const isSafari = /apple/i.test(vendor) && /safari/i.test(userAgent);
    const isChrome = /google/i.test(vendor) && /chrome/i.test(userAgent);
    return isSafari && !isChrome;
}
export const copyTextToClipboard = (text) => {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    try {
        navigator.clipboard.writeText(text);
    }
    catch (err) {
        fallbackCopyTextToClipboard(text);
    }
};
const fallbackCopyTextToClipboard = (text) => {
    const logger = Container.get(Logger).context('utils.ts#fallbackCopyTextToClipboard');
    var textArea = document.createElement('textarea');
    textArea.value = text;
    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
    }
    catch (err) {
        logger.error(err);
    }
    document.body.removeChild(textArea);
};
export const moneyToCoins = (value, rewardRation) => {
    return value * (rewardRation / 100);
};
export const parseMoney = value => {
    return `${value / 100}`;
};
export const notificationAudio = new Audio(`${process.env.BASE_URL}/sounds/notification.wav`);
export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
export function cdn(path) {
    return `${process.env.BASE_URL}${path}`;
}
export function asyncDerived(store, fn) {
    derived(store, (state, set) => {
        fn(state).then(set).catch(console.error);
    });
}
const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
export function getMonthAbbrev(date) {
    const month = new Date(date).getUTCMonth();
    return months[month];
}
export function getSiteSettings() {
    const scripts = [...document.getElementsByTagName('script')];
    const scriptTag = document.currentScript ||
        scripts.find(({ outerHTML }) => outerHTML && outerHTML.includes(process.env.BASE_URL)) ||
        document.getElementById('twism-widget-script') ||
        document.getElementById('twism-widget-js');
    const src = scriptTag.attributes.getNamedItem('src').value;
    const [url, query] = src.split('?');
    const queryArgs = query.split('&');
    const parsedQueryArgs = {};
    queryArgs.forEach(queryArg => {
        const [name, value] = queryArg.split('=');
        parsedQueryArgs[name] = value;
    });
    return parsedQueryArgs;
}
export const getHeightHeaderDash = pendingCoins => {
    return pendingCoins > 0 ? 227 : 185;
};
export function getCoinsExpiringSoon(items = []) {
    const groupedByDate = items
        .reduce((acc, curr) => {
        const currDate = dayjs.utc(curr.expiresAt).format('YYYY-MM-DD');
        if (Object.prototype.hasOwnProperty.call(acc, currDate)) {
            return Object.assign(Object.assign({}, acc), { [currDate]: Number(acc[currDate]) + Number(curr.coinsAmount) });
        }
        return Object.assign(Object.assign({}, acc), { [currDate]: Number(curr.coinsAmount) });
    }, {});
    const sortedData = Object.entries(groupedByDate).sort((date1, date2) => {
        const now = dayjs.utc();
        const diffDate1 = now.diff(dayjs.utc(date1[0]));
        const diffDate2 = now.diff(dayjs.utc(date2[0]));
        return diffDate2 - diffDate1;
    });
    const [_, coinsExpiringSoon] = (sortedData === null || sortedData === void 0 ? void 0 : sortedData[0]) || [undefined, 0];
    return { coinsExpiringSoon };
}
export function isProbablyGoogleBot() {
    if (typeof navigator === 'undefined')
        return false;
    const ua = navigator.userAgent || '';
    // Include other Google crawlers if relevant
    return /\b(Googlebot|AdsBot-Google|Mediapartners-Google)\b/i.test(ua);
}
